<template>
<v-dialog
    v-if="shipment != null"
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Redirect Package: <span style="font-family: monospace">{{shipment.tracking_number}}</span></v-card-title>

        <v-card-text>
            <p>By clicking "Redirect" below, you are requesting that this package be redirected to the access point closest to the delivery address.</p>
            <ul>
                <li>Typically, it takes 4 business hours to confirm that a package has been redirected to an access point</li>
                <li>Once a package has been redirected, it can not be modified again (this can not be undone)</li>
                <li>Sometimes the carriers are not able to redirect packages</li>
            </ul>

            <v-textarea
                label="Notes / Special Request"
                v-model="notes"
                autofocus
                auto-grow
                rows="1"
                style="margin-top: 15px"
            />

        </v-card-text>

        <v-card-actions>
            <m-restricted-button
                text
                @click="onClickTestEmail"
                v-if="this.$rc.$state.isAuthActorSystemAdmin()"
            >
                Test Email
            </m-restricted-button>

            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Redirect Package
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            notes: null,
            shipment: null,
        }
    },

    methods: {

        showDialog(shipment)
        {
            this.dialog = true;
            this.shipment = _.cloneDeep(shipment);
        },

        requestRedirect(is_test)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/conversation/chips/actions/shipment-request-redirect',

                'params' : {
                        'organization_id': this.shipment.organization_id,
                        'conversation_id': this.$route.params.conversation_id,
                        'tracking_number': this.shipment.tracking_number,
                        'notes': this.notes,
                        'action_send_email_test': is_test,
                        'action_send_email_actual': !is_test,
                        'action_add_note_to_conversation': true,
                    },

                'on_success': (data) => {
                         this.$rc.alert('Redirect Requested','Your request to redirect this package has been received.');
                         this.dialog = false;
                    },

                'on_error': 'Unable to request package be redirected.',
            });
        },

        onOk()
        {
            this.requestRedirect(false);
        },

        onClickTestEmail()
        {
            this.requestRedirect(true);
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>